import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-sample-data',
  templateUrl: './sample-data.component.html',
  styleUrls: ['./sample-data.component.css']
})
export class SampleDataComponent implements OnInit {
  dummy: any=false;
  check: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private dialogRef: MatDialogRef<SampleDataComponent>  ) { }

  ngOnInit() {
    console.log(this.data);

    
    if(this.data=="true"){
      this.check = this.data
      this.dummy=this.data
    }
    
  }
  enableSampleData(){
    console.log(this.dummy)
    this.dialogRef.close(this.dummy)
  }
  close(){
    this.dialogRef.close()
  }
  slide(event){    
    this.dummy=event.target.checked
    console.log(this.dummy);
    
  }
}
